import { createContext, useEffect, useState } from "react";
import Loader from "../components/common/Loader";
export const AuthContext = createContext();
export const LoaderContext = createContext();

const AuthProvider = ({ children }) => {
  const [authDetails, setAuthDetails] = useState(
    JSON.parse(localStorage.getItem("login"))
  );
  const pageSize = 20;
  useEffect(() => {
    // Set initial auth details from localStorage
    const storedAuth = JSON.parse(localStorage.getItem("login"));

    if (storedAuth) {
      setAuthDetails(storedAuth);
    }
  }, []);

  const setLoginItem = (logInItem) => {
    setAuthDetails(logInItem);
    localStorage.setItem("login", JSON.stringify(logInItem));
  };
  const ucFirst = (word) => word.charAt(0).toUpperCase() + word.slice(1); // Upper Case First Leter
  const stringifyNumber = (n) => {
    const special = [
      "zeroth",
      "first",
      "second",
      "third",
      "fourth",
      "fifth",
      "sixth",
      "seventh",
      "eighth",
      "ninth",
      "tenth",
      "eleventh",
      "twelfth",
      "thirteenth",
      "fourteenth",
      "fifteenth",
      "sixteenth",
      "seventeenth",
      "eighteenth",
      "nineteenth",
    ];
    const deca = [
      "twent",
      "thirt",
      "fort",
      "fift",
      "sixt",
      "sevent",
      "eight",
      "ninet",
    ];
    const bigs = [
      "",
      "thousand",
      "million",
      "billion",
      "trillion",
      "quadrillion",
      "quintillion",
    ]; // Add more as needed
    let numStr = "";

    const chunkify = (num) => {
      const chunks = [];
      while (num > 0) {
        chunks.push(num % 1000);
        num = Math.floor(num / 1000);
      }
      return chunks;
    };

    const chunkToWords = (chunk) => {
      if (chunk === 0) return "";
      let words = "";
      const hundreds = Math.floor(chunk / 100);
      const tens = chunk % 100;
      if (hundreds > 0) {
        words += special[hundreds] + " hundred";
        if (tens > 0) words += " and ";
      }
      if (tens < 20) {
        words += special[tens];
      } else {
        const tensIndex = Math.floor(tens / 10) - 2;
        words += deca[tensIndex];
        if (tens % 10 !== 0) words += "y-" + special[tens % 10];
      }
      return words;
    };

    const chunks = chunkify(n);
    const wordsArray = chunks.map((chunk, index) => {
      const bigName = bigs[index];
      const chunkWords = chunkToWords(chunk);
      return chunkWords + (chunkWords && bigName ? " " + bigName : "");
    });

    numStr = wordsArray.reverse().join(" ");

    return ucFirst(numStr);
  };
  const handlePhoneNumberInput = (value) => {
    // Remove non-numeric characters
    const cleanedValue = value.replace(/\D/g, "");

    // Limit to 10 digits
    return cleanedValue.slice(0, 10);
  };

  const validateEmail = (email) => {
    // Basic regex for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    return emailRegex.test(email);
  };
  const validateHours = (value, field) => {
    let errorMessage = "";

    if (value === "") {
      errorMessage = "This field is required";
    } else if (isNaN(value)) {
      errorMessage = "Only numbers are allowed";
    } else if (Number(value) < 0) {
      errorMessage = "Value cannot be negative";
    } else if (Number(value) > 24) {
      errorMessage = "Max 24 hours allowed"; // or whatever your limit is
    }

    return errorMessage;
  };

  return (
    <AuthContext.Provider
      value={{
        pageSize,
        validateHours,
        validateEmail,
        handlePhoneNumberInput,
        authDetails,
        setLoginItem,
        stringifyNumber,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

const LoaderProvider = ({ children }) => {
  const [loader, setLoader] = useState(false);

  return (
    <LoaderContext.Provider value={{ loader, setLoader }}>
      {children}
      {loader && <Loader />}
    </LoaderContext.Provider>
  );
};

export { LoaderProvider };
export default AuthProvider;
